import { useTranslation } from '@/hooks/useTranslation';
import { BrowseActiveFilter, FILTER_TYPE } from '@/pages/browse/types';

import { matchesFilterQuery } from './filterQuery';
import { FilterMenuItem } from './FilterMenuItem';

interface FilterListComplianceProps {
    query: string;
    onSelect: (type: string, filter: BrowseActiveFilter) => void;
}

export function FilterListCompliance({ query, onSelect }: FilterListComplianceProps) {
    const { t } = useTranslation();

    const options = [
        {
            text: t('ITEMS_SEARCH_FILTER.MENU.COMPLIANT'),
            val: 'true',
            type: FILTER_TYPE.COMPLIANT_ITEMS,
        },
        {
            text: t('ITEMS_SEARCH_FILTER.MENU.NON_COMPLIANT'),
            val: 'false',
            type: FILTER_TYPE.NON_COMPLIANT_ITEMS,
        },
    ];

    return (
        <>
            {options
                .filter((option) => matchesFilterQuery(option.text, query))
                .map((option) => (
                    <li key={option.type} className="tw-list-none">
                        <FilterMenuItem
                            onSelect={() => {
                                onSelect(option.type, {
                                    name: option.text,
                                    type: option.type,
                                    itemsQuery: { compliant: option.val },
                                    searchKey: 'compliant',
                                });
                            }}
                        >
                            {option.text}
                        </FilterMenuItem>
                    </li>
                ))}
        </>
    );
}
